var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9995 3C10.9995 2.44772 11.4472 2 11.9995 2C12.5518 2 12.9995 2.44772 12.9995 3V4C12.9995 4.02774 12.9984 4.05522 12.9962 4.08239C15.8355 4.55707 17.9996 7.02582 17.9996 10V11.9574C17.9996 12.3881 18.1555 12.8042 18.4385 13.1289L19.0829 13.8682C21.1697 16.2623 19.4694 20 16.2935 20H14C14 21.1046 13.1046 22 12 22C10.8954 22 10 21.1046 10 20H7.7056C4.5297 20 2.82937 16.2623 4.91619 13.8682L5.56063 13.1289C5.84364 12.8042 5.99956 12.3881 5.99956 11.9574V10C5.99956 7.02585 8.16352 4.55712 11.0029 4.08241C11.0006 4.05523 10.9995 4.02775 10.9995 4V3ZM11.9996 6C9.79042 6 7.99956 7.79086 7.99956 10V11.9574C7.99956 12.8712 7.66875 13.7542 7.06827 14.443L6.42383 15.1824C5.46491 16.2825 6.24623 18 7.7056 18H16.2935C17.7529 18 18.5342 16.2825 17.5753 15.1824L16.9308 14.443C16.3304 13.7542 15.9996 12.8712 15.9996 11.9574V10C15.9996 7.79086 14.2087 6 11.9996 6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.d41148b55fc6466f32ed54c7b3198d53.svg";
export { ForwardRef as ReactComponent };